export const emailRegex = /^[a-zA-Z0-9.\-_+']+@[a-zA-Z0-9.\-_+]+\.[a-zA-Z]{2,}$/;
export const passwordRegex = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W)(?=.{8,50})/;
export const phoneNumberRegex = /^\d{10}$/;
export const inAppWebview = /((iPhone|iPod|iPad).*AppleWebKit(?!.*Version|.*CriOS|.*FxiOS)|; wv|;wv)/i;
